export default __webpack_public_path__ + "static/media/wordclouds-teaser.5421e0c2.png";